import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.activity-data-tri-state-control {
  display: inline-flex;
  align-items: center;
  gap: ${dt('activityDataValidation.button.gap')};
  flex-shrink: 0;
}

.activity-data-tri-state-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${dt('activityDataValidation.button.size')};
  height: ${dt('activityDataValidation.button.size')};
  padding: 0;
  border: 1px solid ${dt('activityDataValidation.button.borderColor')};
  border-radius: 6px;
  background: ${dt('activityDataValidation.button.defaultBackground')};
  color: ${dt('surface.700')};
  cursor: pointer;
}

.activity-data-tri-state-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.activity-data-tri-state-btn .pi {
  font-size: ${dt('activityDataValidation.button.iconSize')};
}

.activity-data-tri-state-btn.is-yes {
  background: ${dt('activityDataValidation.yes.background')};
  border-color: ${dt('activityDataValidation.yes.borderColor')};
  color: ${dt('activityDataValidation.yes.iconColor')};
}

.activity-data-tri-state-btn.is-no {
  background: ${dt('activityDataValidation.no.background')};
  border-color: ${dt('activityDataValidation.no.borderColor')};
  color: ${dt('activityDataValidation.no.iconColor')};
}

.activity-data-tri-state-btn.is-not-provided {
  background: ${dt('activityDataValidation.notProvided.background')};
  border-color: ${dt('activityDataValidation.notProvided.borderColor')};
  color: ${dt('activityDataValidation.notProvided.iconColor')};
}

.activity-data-capacity-input-block {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
}

.activity-data-capacity-previous-hint {
  margin: ${dt('activityDataValidation.previousCapacityHint.marginTop')} 0 0 0;
  font-size: ${dt('activityDataValidation.previousCapacityHint.fontSize')};
  line-height: ${dt('activityDataValidation.previousCapacityHint.lineHeight')};
  color: ${dt('activityDataValidation.previousCapacityHint.color')};
  text-align: right;
  white-space: nowrap;
}

.activity-data-capacity-controls {
  display: contents;
}
`;
